<template>
  <!-- Container for the order summary box with padding -->
  <div>
    <!-- Order Summary title  cartProductsProgress-->
    <div
      class="d-none d-md-block text-primaryText text-h6 font-weight-bold mb-6"
    >
      Order Summary
    </div>
    <!-- Loop through each product in the checkoutProductList -->
    <div v-show="cartProductsProgress">
      <CheckoutProductListSkeleton :checkoutProductList="checkoutProductList" />
    </div>

    <div v-show="!cartProductsProgress">
      <div
        v-for="(item, index) in checkoutProductList"
        :key="item.id || index"
        class="d-flex align-start mb-5"
      >
        <!-- Product image: uses base path and custom image attribute -->
        <!-- Concatenate base path and image filename -->
        <!-- Alt text for accessibility -->
        <!-- Fixed image width -->
        <!-- Fixed image height -->
        <!-- Rounded corners and right margin -->
        <div style="width: 77px; flex-shrink: 0" class="mr-2">
          <!-- Builder images -->
          <div v-if="item.customAttributes.isPersonalize == 1">
            <div
              v-if="builderSession(item) && item.thumbnailUrl"
              v-for="(builderItem, itemIndex) in item.thumbnailUrl"
              :key="itemIndex"
              :class="itemIndex !== item.thumbnailUrl.length - 1 ? 'mb-2' : ''"
            >
              <v-img
                :src="builderItem ? builderItem : item.customAttributes.image"
                :alt="item.name"
                @click="showImagesDialog(builderItem)"
              ></v-img>
            </div>

            <div
              v-else-if="isDesignProject(item) && item.builderSessionItemList"
              v-for="(
                builderSessionItem, currentIndex
              ) in item.builderSessionItemList"
              :key="builderSessionItem.id"
              :class="
                currentIndex !== item.builderSessionItemList.length - 1
                  ? 'mb-2'
                  : ''
              "
            >
              <!-- width="76"
                height="auto"
                class="d-block" -->
              <v-img
                v-if="builderSessionItem.thumbnailUrl"
                :src="builderSessionItem.thumbnailUrl"
                :alt="item.name"
                @click="showImagesDialog(builderSessionItem.thumbnailUrl)"
              ></v-img>
              <v-skeleton-loader
                v-else
                class=""
                width="100%"
                type="image"
              ></v-skeleton-loader>
            </div>

            <div v-else>
              <v-img
                :src="imageBasePathUrl + item.customAttributes.image"
                :alt="item.name"
                width="76"
                height="76"
                class="d-block"
              ></v-img>
            </div>
          </div>
          <div v-else>
            <v-img
              :src="imageBasePathUrl + item.customAttributes.image"
              :alt="item.name"
              width="76"
              height="76"
              class="d-block"
            ></v-img>
          </div>
        </div>

        <!-- Product details -->
        <div class="flex-grow-1 d-flex flex-column justify-center">
          <!-- Name -->
          <div class="font-weight-bold mb-1">
            {{ item.name }}
          </div>

          <!-- Qty -->
          <div class="text-caption grey--text">Qty: {{ item.qty }}</div>

          <!-- Price -->
          <div class="text-caption grey--text mb-1">
            ${{ formatAmount(item.price) }}
          </div>

          <!-- Expansion Panel for  configurable and giftcard to see more details-->
          <v-expansion-panels
            v-show="
              item.productType == 'configurable' ||
              item.productType == 'giftcard'
            "
            class="active-panel-edited pa-0 ma-0"
          >
            <v-expansion-panel
              elevation="0"
              class="pa-0 ma-0 bg-transparent elevation-0"
              v-if="item.productOption"
            >
              <v-expansion-panel-title
                class="pa-0 ma-0 text-caption font-weight-medium text-primary"
                style="min-height: 30px"
              >
                See Details
              </v-expansion-panel-title>

              <!-- Giftcard details -->
              <v-expansion-panel-text
                v-if="item.productType == 'giftcard'"
                class="cart-product-list-expansion text-caption pt-1"
              >
                <p class="font-weight-bold text-black mb-1">Gift Card Sender</p>
                <p v-if="item.productOption.infoBuyRequest" class="mb-2">
                  {{ item.productOption.infoBuyRequest.giftcardSenderName
                  }}<br />
                  {{ item.productOption.infoBuyRequest.giftcardSenderEmail }}
                </p>

                <p class="font-weight-bold text-black mb-1">
                  Gift Card Recipient
                </p>
                <p v-if="item.productOption.infoBuyRequest">
                  {{ item.productOption.infoBuyRequest.giftcardRecipientName
                  }}<br />
                  {{ item.productOption.infoBuyRequest.giftcardRecipientEmail }}
                </p>
              </v-expansion-panel-text>

              <!-- Configurable product options -->
              <v-expansion-panel-text
                v-else
                class="cart-product-list-expansion text-caption pa-0 pt-1"
              >
                <p class="font-weight-bold text-black mb-1">Option</p>
                <p
                  v-if="item.productOption.attributesInfo.length > 0"
                  class="mb-0"
                >
                  {{ item.productOption.attributesInfo[0].value }}
                </p>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- Total Price -->
        <div>
          <div class="font-weight-bold">
            ${{ formatAmount(item.baseRowTotal) }}
            <span v-if="item.customAttributes.per">
              <span class="text-caption grey--text">
                per {{ item.customAttributes.per }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="d-md-block d-none">
      <div v-show="showStoreCredit">
        <v-divider class="my-4"></v-divider>
        <StoreCredit
          class="pa-3"
          :giftCardCreditBalance="giftCardCreditBalance"
          :isCheckoutProcessing="isCheckoutProcessing"
          :showStoreCredit="showStoreCredit"
          @useStoreCreditClick="handleUseStoreCreditClick"
        />
      </div>

      <!-- isCouponLoading -->
      <v-divider class="my-6"></v-divider>
      <CouponCode
        :isUser="isUser"
        :isCouponLoading="isCouponLoading"
        :discountGuestCode="discountGuestCode"
        :userDiscountCodeList="userDiscountCodeList"
        :isCheckoutProcessing="isCheckoutProcessing"
        @checkGuestCouponCode="checkGuestCouponCode"
        @removeGuestCouponCode="removeGuestCouponCode"
        @checkUserCouponCode="checkUserCouponCode"
        @removeUserCouponCode="removeUserCouponCode"
      />
      <v-divider class="my-4"></v-divider>
    </div>

    <!-- Totals Section  cartTotalAmtProgress    "-->
    <div v-if="isCheckoutProcessing">
      <cart-total-skeleton :subSkeleton="subSkeleton" />
    </div>

    <div v-else>
      <!-- Subtotal row -->
      <div class="d-flex justify-space-between mb-2">
        <span class="grey--text">Subtotal</span>
        <!-- Label for subtotal -->
        <span>${{ formatAmount(checkoutProductTotalAmt.baseSubtotal) }}</span>
        <!-- Display subtotal amount -->
      </div>

      <!-- Tax row, shows tax percent if available -->
      <div class="d-flex justify-space-between mb-2">
        <span class="grey--text">
          Tax
          <span v-if="checkoutProductTotalAmt.taxPercent">
            ({{ checkoutProductTotalAmt.taxPercent }}%)
            <!-- Show tax percent if available -->
          </span>
        </span>
        <span>${{ formatAmount(checkoutProductTotalAmt.taxAmount) }}</span>
        <!-- Display tax amount -->
      </div>
      <!-- Shipping row -->
      <div class="d-flex justify-space-between mb-2">
        <span class="grey--text">Shipping</span>
        <!-- Label for shipping -->
        <span>
          <span
            >${{
              formatAmount(checkoutProductTotalAmt.baseShippingAmount)
            }}</span
          >
          <!-- Display shipping amount -->
        </span>
      </div>
      <!-- Discount row -->
      <div
        class="d-flex justify-space-between mb-2"
        v-if="checkoutProductTotalAmt.discountAmount"
      >
        <span class="grey--text">
          Discount
          <span> ({{ checkoutProductTotalAmt.couponCode }}) </span>
        </span>
        <span>
          ${{ formatAmount(checkoutProductTotalAmt.discountAmount) }}</span
        >
        <!-- Display Discount amount -->
      </div>
      <!-- Discount row -->

      <div v-if="isStoreCreditUsed" class="d-flex justify-space-between mb-2">
        <span class="grey--text"> Store Credit </span>
        <span> ${{ formatAmount(storeCreditUsed) }}</span>
        <!-- Display Discount amount -->
      </div>
      <!-- Divider before total -->
      <v-divider class="my-4"></v-divider>
      <!-- Grand total row -->
      <div class="d-flex justify-space-between align-center">
        <span class="font-weight-bold">Total</span>
        <!-- Label for total -->
        <span class="font-weight-bold">
          ${{ formatAmount(checkoutProductTotalAmt.grandTotal) }}
          <!-- Display grand total amount -->
        </span>
      </div>
    </div>
    <ImageDialog
      v-model="openImageDialog"
      :images="imageSrcs"
      title="Product Images"
    />
  </div>
</template>

<script>
const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;
import CheckoutProductSkeleton from "@/components/crane/cart-product/CheckoutProductSkeleton.vue";
import CartTotalSkeleton from "./CartTotalSkeleton.vue";

import CheckoutProductListSkeleton from "./CheckoutProductListSkeleton.vue";
import GiftCardSkeleton from "./GiftCardSkeleton.vue";
import CouponCode from "./CouponCode.vue";
import StoreCredit from "./StoreCredit.vue";
import ImageDialog from "@/components/common/ImageDialog.vue";
import { getCookieByName } from "@/services/auth";
import { formatAmount } from "@/services/util.service";

export default {
  name: "CheckoutProductList", // Name of the component for Vue
  props: [
    "checkoutProductList", // Array of products to display in the summary
    "checkoutProductTotalAmt", // Object containing subtotal, tax, shipping, and total amounts
    "discountGuestCode",
    "isCouponLoading",
    "isUser",
    "userDiscountCodeList",
    "giftCardCreditBalance",
    "storeCreditUsed",
    "isCheckoutProcessing",
    "cartProductsProgress",
  ],
  components: {
    CheckoutProductSkeleton,
    CartTotalSkeleton,
    CheckoutProductListSkeleton,
    GiftCardSkeleton,
    CouponCode,
    ImageDialog,
    StoreCredit,
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      guestCouponCode: this.discountGuestCode,
      userDiscountTextCode: "",
      openImageDialog: false,
    };
  },
  computed: {
    // Returns the base URL for images from environment variable
    imageBasePathUrl() {
      // Access environment variable for image base path
      return import.meta.env.VITE_IMAGE_PATH_URL;
    },
    guestQuoteId: function () {
      return getCookieByName(crGuestQuoteId);
    },
    userAuth: function () {
      return this.$store.state.auth.userAuth;
    },
    isStoreCreditUsed() {
      const val = Number(this.storeCreditUsed);
      console.log("val", val);
      // Return false if val is 0 or -0, true otherwise
      return val !== 0;
    },
    subSkeleton() {
      let count = 1;
      if (this.isStoreCreditUsed && this.checkoutProductTotalAmt.couponCode) {
        count = 3; // both true
      } else if (
        this.isStoreCreditUsed ||
        this.checkoutProductTotalAmt?.couponCode
      ) {
        count = 2; // only one true
      }
      return count;
    },
    showStoreCredit() {
      return (
        this.isUser &&
        Number(this.giftCardCreditBalance) > 0 &&
        !this.isStoreCreditUsed &&
        Number(this.checkoutProductTotalAmt?.grandTotal) > 0
      );
    },
  },
  watch: {
    discountGuestCode(newValue, oldValue) {
      this.guestCouponCode = newValue;
      if (!newValue && oldValue) {
        this.$nextTick(() => this.$refs.guestCouponCodeForm?.reset());
      }
    },
    userDiscountCodeList() {
      this.userDiscountTextCode = null;
    },
  },
  methods: {
    formatAmount,
    builderSession(product) {
      let builderSessionOne = null;
      if (
        product &&
        product.options &&
        product.options.options &&
        product.options.options.length > 0
      ) {
        let optionsList = product.options.options;
        builderSessionOne = optionsList.find(
          (x) => x.label == "BuilderSessionId"
        );

        if (builderSessionOne) {
          return true;
        }
      }
      return false;
    },

    isDesignProject(product) {
      let designProjectId = null;
      if (
        product &&
        product.options &&
        product.options.options &&
        product.options.options.length > 0
      ) {
        let optionsList = product.options.options;
        designProjectId = optionsList.find(
          (x) => x.label == "DESIGN_PROJECT_ID"
        );

        if (designProjectId) {
          return true;
        }
      }
      return false;
    },
    checkGuestCouponCode(data) {
      this.$emit("checkGuestCouponCode", data);
    },
    removeGuestCouponCode(data) {
      this.$emit("removeGuestCouponCode", data);
    },
    checkUserCouponCode(data) {
      this.$emit("checkUserCouponCode", data);
    },
    removeUserCouponCode(item) {
      this.$emit("removeUserCouponCode", item);
    },
    handleUseStoreCreditClick() {
      this.$emit("useStoreCredit");
    },
    showImagesDialog(data) {
      this.imageSrcs = [];
      this.imageSrcs.push(data);
      this.sliderImgPath = this.imageSrcs[0];
      this.openImageDialog = true;
    },
  },
  async created() {},
};
</script>
<style lang="scss">
.checkout-product-button-height {
  height: 44px !important;
}
.cart-product-list-expansion .v-expansion-panel-text__wrapper {
  padding: 0 0px 0px !important;
}

.active-panel-edited .v-expansion-panel-title__overlay {
  background-color: transparent !important;
}

@media (max-width: 390px) {
  .v-field__input {
    font-size: 12px !important;
  }
}

.v-input__details {
  padding-top: 0px;
}

.pb-20 {
  padding-bottom: 20px !important;
}

.chekout-page-image-skeleton .v-skeleton-loader__image {
  height: 60px;
}

.checkout-page-text-field .v-skeleton-loader__text {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 12px;
  margin-left: 0px;
}

.checkout-page-carts-text-field .v-skeleton-loader__text {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 4px;
}

.checkout-page-btn .v-skeleton-loader__button {
  margin-right: 0px;
  margin-top: 0px;
}

.checkout-page-guest-btn .v-skeleton-loader__button {
  margin-right: 0px;
  margin-top: 0px;
  margin-left: 0px;
}

// start.... below code for making textfield just like stripe textfield.
// need to check if needed or not
// .coupon-field-input .v-field__input {
//   border: 1px solid #e6e6e6;
//   background-color: #fff;
//   border-radius: 5px;
//   padding: 12px;
//   height: 45px;
// }

// .focus-effect .v-field__input {
//   transition: box-shadow 0.2s ease, border-color 0.2s ease;
// }

// .focus-effect .v-field__input:focus-within {
//   border-color: #3d5789;
//   box-shadow: 0px 0px 0px 3px #ccd3e0;
// }

// .coupon-field-input .v-field__input::placeholder {
//   color: #858383;
//   opacity: 1;
// }

// .coupon-field-input .v-field--error .v-field__input {
//   border: 2px solid #df1b41 !important;
//   border-color: #df1b41 !important;
// }

// .focus-effect .v-field--error .v-field__input:focus-within {
//   border-color: #df1b41 !important;

//   box-shadow: 0px 0px 0px 3px #fafafa !important;
// }

// .coupon-field-input .v-input__details {
//   padding-left: 0px;
// }
// .coupon-field-input .v-messages__message {
//   font-size: 14px;
//   color: #df1b41;
// }
// end....
</style>
